import type { ReactNode } from "react";

// DetailsFold is a Review card's closed-by-default fold for what the founder
// reads only on demand: the reasoning and the provenance lines (0051 S1a).
// A native <details>: it needs no state, opens with a click or the keyboard,
// and keeps its content in the DOM. The caller renders it only when it has
// content.
export function DetailsFold({ children }: { children: ReactNode }) {
  return (
    <details data-testid="review-details" className="mt-6 min-w-0">
      <summary className="cursor-pointer select-none font-mono text-[10px] uppercase tracking-widest text-ink-400 hover:text-ink-200 transition-colors">
        Details
      </summary>
      <div className="mt-3 space-y-4">{children}</div>
    </details>
  );
}
